import { render, staticRenderFns } from "./VibrationParameterTab.vue?vue&type=template&id=ba12181e&scoped=true"
import script from "./VibrationParameterTab.vue?vue&type=script&lang=ts"
export * from "./VibrationParameterTab.vue?vue&type=script&lang=ts"
import style0 from "./VibrationParameterTab.vue?vue&type=style&index=0&id=ba12181e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12181e",
  null
  
)

export default component.exports